var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-72127a0c\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./page404.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Repositorios\\AGENDA_PREFEITO\\front-end\\application\\views\\commons\\page404.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] page404.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72127a0c", Component.options)
  } else {
    hotAPI.reload("data-v-72127a0c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./application/views/commons/page404.vue
// module id = 368
// module chunks = 1